/* eslint-disable @angular-eslint/prefer-standalone */
import { Functions } from 'src/app/shared/functions/functions';
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'currencyLocalePipe',
  standalone: false
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyLocalePipe implements PipeTransform {
  constructor(private readonly functions: Functions) { }
  /**
  * Formata valor monetário com casas decimais dinâmicas
  * @param currency - Valor a ser formatado
  * @param field - (Opcional) Nome do campo para buscar tamanho de decimais do localstorage. Se não informado, usa 2 decimais por padrão
  */

  transform(currency: string | number, field?: string): string {
    currency = currency === '' || currency === undefined ? '0' : currency.toString();
    const decimals =
    field ? this.functions.getSizeFieldsDecimal(field) : 2;
    return '$' + this.functions.maskCurrencyDependingOnLocale(currency, decimals);
  }

}
